import { roleReducer,isBlockingReducer,pathNameReducer  } from './roleReducer';
import themeReducer from './themeReducer';
import socketReducer from './socketReducer';
import listReducer from './listReducer';
import treeReducer from './treeReducer';
import {isBlockingInfoChannelReducer,pathNameInfoChannelReducer} from './infoChannelReducer';
import fileManagerReducer from './fileManagerReducer';
import deviceProfileReducer from './deviceProfileReducer';
import { isBlockingSettingsReducer, pathNameSettingsReducer } from './settingsReducer';
export default {
    role: roleReducer,
    is_blocking: isBlockingReducer,
    theme: themeReducer,
    path_name: pathNameReducer,
    sailsSocket: socketReducer,
    list: listReducer,
    tree: treeReducer,
    is_blocking_infochannel:isBlockingInfoChannelReducer,
    path_name_infochannel: pathNameInfoChannelReducer,
    file_manager: fileManagerReducer,
    device_profile: deviceProfileReducer,
    is_blocking_settings: isBlockingSettingsReducer,
    path_name_settings: pathNameSettingsReducer,
};
